import * as React from 'react';

import * as styles from './ListingDesktopContent.css';
import { IDailyRentOfferForMobileSite } from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { ListingDesktopLoading } from '../../components/ListingDesktop';
import { BANNER_POSITION_TYPES } from '../../constants/banner';
import { BannerContainer } from '../BannerContainer';
import { EmptyListingContainer } from '../EmptyListingContainer';
import { EmptyListingSuggestionsContainer } from '../EmptyListingSuggestionsContainer';
import { ListingDesktopFooterContainer } from '../ListingDesktopFooterContainer';
import { ListingHeaderContainer } from '../ListingHeaderContainer';
import { OfferCardDesktopContainer } from '../OfferCardDesktopContainer';

interface IListingDesktopContentProps {
  isLoading: boolean;
  offers: IDailyRentOfferForMobileSite[];
  onEmptyListingShow(): void;
  onOfferMouseEnter?: (realtyId: number) => void;
  onOfferMouseLeave?: (realtyId: number) => void;
}

export const ListingDesktopContent = ({
  isLoading,
  offers,
  onEmptyListingShow,
  onOfferMouseEnter,
  onOfferMouseLeave,
}: IListingDesktopContentProps) => {
  const hasOffers = offers.length > 0;
  const isEmpty = !hasOffers && !isLoading;

  let content: React.ReactNode;
  if (isEmpty) {
    content = (
      <div className={styles['empty-content']}>
        <EmptyListingContainer onShow={onEmptyListingShow} />
        <EmptyListingSuggestionsContainer />
      </div>
    );
  } else if (isLoading) {
    content = <ListingDesktopLoading />;
  } else {
    const items = offers.reduce<React.ReactNode[]>((acc, offer, index) => {
      const position = index + 1;

      acc.push(
        <OfferCardDesktopContainer
          key={offer.id}
          offer={offer}
          offerPosition={position}
          offersLength={offers.length}
          onMouseEnter={onOfferMouseEnter}
          onMouseLeave={onOfferMouseLeave}
        />,
      );

      const bannerType = BANNER_POSITION_TYPES[position];
      if (bannerType) {
        acc.push(
          <BannerContainer key={`banner-${offer.id}`} offer={offer} position={position} bannerType={bannerType} />,
        );
      }

      return acc;
    }, []);

    content = <div className={styles['offers-grid']}>{items}</div>;
  }

  return (
    <div className={styles['root']}>
      <ListingHeaderContainer isLoading={isLoading} />
      {content}
      {hasOffers && <ListingDesktopFooterContainer />}
    </div>
  );
};

ListingDesktopContent.displayName = 'ListingDesktopContent';
